<template>
      <div class="container">
        <div class="wrapper box-shadow">
            <div class="row align-items-center img-panel">
                <div class="col text-center my-3">
                    <loading v-show="isLoading" color="#00a088" :isFullScreen="false"></loading>
                    <img :src="fileLink" 
                        @click="toggleImgModal(true)"
                        title="Click to see a larger image." 
                        v-if="fileType == 'image'">
                    <video controls v-if="fileType == 'video'">
                        <source :src="fileLink" type="video/mp4">
                    </video>
                </div>
            </div>
            <div class="row icon-panel">
                <div class="col-md-6 text-left">
                    <div class="social-share" data-initialized="true"
                         :data-wechat-qrcode-title="$t('share.link.wechat_qrcode_title')"
                         :data-wechat-qrcode-helper="$t('share.link.wechat_qrcode_helper')"
                    >
                        <span class="social-share-tip">{{$t("share.link.share_to")}}</span>
                        <a href="#" class="social-share-icon icon-facebook"></a>
                        <a href="#" class="social-share-icon icon-twitter"></a>
                        <a href="#" class="social-share-icon icon-linkedin"></a>
                        <a href="#" class="social-share-icon icon-weibo"></a>
                        <a href="#" class="social-share-icon icon-wechat"></a>
                    </div>
                </div>
                <div class="col-md-6 text-right">
                    <b-button-group>
                        <b-button @click="copyBtnClick" variant="link">
                            <span class="oi oi-link-intact"></span>
                            {{$t("share.link.copy_link_btn")}}
                        </b-button>
                        <b-button variant="primary" @click="downloadBtnClick" :disabled="downloadBtnDisEnable" style="border-radius: .25rem">
                            <span class="oi oi-arrow-bottom"></span>
                            {{$t("share.link.download_btn")}}
                        </b-button>
                    </b-button-group>
                </div>
            </div>
            <div class="row" v-show="this.fileExpired">
                <div class="col">
                    <p class="tip">
                      Note: The file stored on the Cloud Clipboard will expire at {{this.fileExpired}} and will be automatically removed at that time.
                      <b-button 
                      variant="link" 
                      size="sm"
                      @click="deleteResourceClick" v-if="showDeleteBtn" :disabled="deleteBtnDisable"
                      >{{$t("share.link.delete_btn")}}</b-button>
                     </p>
                </div>
            </div>
        </div>
        <input readonly :value="currentURL" id="copy-url" ref="copy-url" type="hidden" />
        <div id="imgModal" v-show="isImgModalShow">
          <span class="close" @click="toggleImgModal(false)">&times;</span>
          <img :src="fileLink" alt="">
        </div>
    </div>
</template>

<script>
import Loading from '../components/Loading.vue'
import 'social-share.js/dist/css/share.min.css'
import 'social-share.js/dist/js/social-share.min.js'
import 'open-iconic/font/css/open-iconic-bootstrap.min.css'
import { getFileData, deleteOwnerFile } from '../services/api.js'

export default {
  name: 'ShareLink',
  components: {
    Loading
  },
  data: () => {
    return {
        fileType: '',
        fileLink: '',
        fileExpired: '',
        currentURL: '',
        isLoading: true,
        isImgModalShow: false,
        downloadBtnDisEnable: true,
        showDeleteBtn: false,
        deleteBtnDisable: false,
    }
  },
  methods: {
    toggleImgModal(isOpen) {
      this.isImgModalShow = isOpen
    },
    copyBtnClick() {
      this.$refs['copy-url'].setAttribute('type', 'text')
      this.$refs['copy-url'].select()
      document.execCommand('Copy')
      this.$refs['copy-url'].setAttribute('type', 'hidden')
      this.$toasted.success('The link has been copied to your clipboard', {duration: 5000, position: 'bottom-right'})
    },
    downloadBtnClick() {
      if(this.fileType == 'video') {
        window.open(this.fileLink, '_blank')
      } else {
        window.open(this.fileLink, '_blank')
        // let fileName = this.fileLink.split('/').pop().split('?')[0]
        // var type = 'image/png'
        // let fileNameLowerCase = fileName.toLowerCase()
        // if(fileNameLowerCase.indexOf('jpg') || fileNameLowerCase.indexOf('jpeg')) {
        //   type = 'image/jpg'
        // }
        // var image = new Image()
        // image.setAttribute('crossOrigin', 'anonymous')
        // image.onload = function () {
        //   var canvas = document.createElement('canvas')
        //   canvas.width = image.width
        //   canvas.height = image.height
        //   var context = canvas.getContext('2d')
        //   context.drawImage(image, 0, 0, image.width, image.height)
        //   var url = canvas.toDataURL(type)
        //   var a = document.createElement('a')
        //   a.download = fileName || 'share'
        //   a.href = url
        //   a.click()
        // }
        // image.src = this.fileLink
      }
    },
    showErrorRespon(error, msg) {
      let response = error.response
      if(response && response.data && response.data.message) {
        if(response.status == "404") {
          this.$toasted.error("The page cannot be found.")
        } else {
          this.$toasted.error(response.data.message)
        }
      } else {
        this.$toasted.error(msg)
      }
    },
    deleteResourceClick() {
      let fileKey = this.ownerThisFile()
      if(fileKey) {
        this.deleteBtnDisable = true
        deleteOwnerFile(fileKey)
          .then(data => {
            if(data.message == 'success') {
              this.deleteOwnerShip()
              this.$toasted.success("The file has been deleted")
              this.$router.push('/tip')
            }
          })
          .catch(err => {
            this.showErrorRespon(err, 'Delete File error, try again later.')
            this.deleteBtnDisable = false
          })
      } else {
        this.deleteBtnDisable = true
        this.$toasted.error("You don't have the permission to delete this file.")
      }
    },
    saveOwnerShip(uuid) {
      if(uuid) {
        let ownFileList = this.getAllSItem()
        if(!ownFileList) {
            ownFileList = {}
        }
        let key = this.$route.params.key
        ownFileList[key] = uuid
        this.setAllSItem(ownFileList)
      }
    },
    deleteOwnerShip() {
      let key = this.$route.params.key
      let ownFileList = this.getAllSItem()
      if(ownFileList && ownFileList.hasOwnProperty(key)) {
          delete ownFileList[key]
          this.setAllSItem(ownFileList)
      }
    },
    ownerThisFile() {
      let ownFileList = this.getAllSItem()
      if(ownFileList) {
        let key = this.$route.params.key
        if(ownFileList.hasOwnProperty(key)) {
            return ownFileList[key]
        }
      }
      return false
    },
    getAllSItem() {
      let sKey = "ownFileList"
      let ownFileList = JSON.parse(localStorage.getItem(sKey))
      return ownFileList ? ownFileList : {}
    },
    setAllSItem(value) {
      let sKey = "ownFileList"
      localStorage.setItem(sKey, JSON.stringify(value))
    }
  },
  created() {
    this.currentURL = location.href

    //init social share
    window.socialShare('.social-share', {
        url: location.href
    })

    //get file
    let key = this.$route.params.key
    getFileData(key)
      .then(file => {
          this.fileLink = file.link
          this.fileType = file.type
          let expiredDate = new Date(file.expired_at * 1000)
          this.fileExpired = expiredDate.toLocaleString()
          this.isLoading = false
          this.downloadBtnDisEnable = false

          let uuid = this.$route.query.uuid
          if(uuid) {
            //save ownership
            this.saveOwnerShip(uuid)

            //replace the url
            this.currentURL = this.currentURL.split('?')[0]  
            window.location.replace(this.currentURL)
          }

          //show delete btn
          if(this.ownerThisFile()) {
            this.showDeleteBtn = true
          }
      })
      .catch(error => {
        this.showErrorRespon(error, 'Download file error, please try again.')
        this.isLoading = false
        this.$router.push('/404')
      })
  },
}
</script>

<style lang="scss">
p.tip {
  color: darkgray;
  font-size: 0.8rem;
  .btn {
    font-size: 0.8rem;
    vertical-align: baseline;
    padding: 0;
  }
}
.social-share .social-share-tip{
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji" !important;
}
</style>


